import React, { Component } from 'react';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from 'react-redux';
import AuthHandlerInstance from '../Classes/AuthHandler'
import swal from '@sweetalert/with-react'
import { icon } from '@fortawesome/fontawesome-svg-core';
import { postComment ,changeDocStatus} from '../store/actions/poDetailsActions.js';

class DocumentRejectPopUp extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            showRejectPopUp:this.props.showRejectPopUp,
            revisedPayload:this.props.revisedPayload,
            fileUploadIds:[],//upload id
            purchaseLIneItemID:this.props.purchaseLIneItemID,
            purchaseOrderId : this.props.purchaseOrderId,
            comments:[],
            writeComment:"",
            docStatus:{
                1:{title:"Saved as draft",badge:"badge-secondary"},
                2:{title:"Document saved",badge:"badge-warning"},
                3:{title:"Accepted",badge:"badge-success"},
                4:{title:"Rejected",badge:"badge-danger"},
                5:{title:"Required another revised document",badge:"badge-danger"}
            },
           
        }
        this.changeDocStatus = this.changeDocStatus.bind(this);
    }

    async changeDocStatus(status,uploadId){
        this.props.changeDocStatus({status,uploadId});
    }

    componentWillMount(){
        
    }

    dateformate(dateVal){
        let d = new Date(dateVal);
        return d.toDateString();
    }

    rejectPopUpAction(st){
        this.props.rejectPopUpAction({},false,true)
    }

    hChange = (e)=>{
        let writeComment = this.state.writeComment
        writeComment = e.target.value;
        let fileUploadIds =[this.state.revisedPayload.param.uploadId]
        this.setState({fileUploadIds,writeComment});
    }

    formSaveAction = async ()=>{
        if(this.state.writeComment.length<1){
            swal("Please write the reason for rejection",{icon:"error"})
        }
        // console.log(this.state.writeComment,"comments")
        else{
            var roles = AuthHandlerInstance.getRoles()
            var IsSMS = 0
            if(roles["5"]){
                IsSMS = 0
            }else{
                IsSMS = 1
            }
            let param = {
                purchaseLIneItemID: this.state.purchaseLIneItemID,
                purchaseOrderId:this.state.purchaseOrderId,
                stageDocumentId: this.state.revisedPayload.param.stageDocumentId,
                status: this.state.revisedPayload.param.status,
                uploadId: this.state.fileUploadIds,
                comment: this.state.writeComment,
                DocumentTypeId: this.state.revisedPayload.param.documentTypeId,
                IsSMS : IsSMS,
                actedBy: AuthHandlerInstance.getUserID()
            }
            this.props.submitPopUpForm(param)
            // await this.props.postComment(param)
            // swal("Saving...",{button:false,icon:"info"})
            // this.changeDocStatus(4,this.state.fileUploadIds)
            // this.rejectPopUpAction(false);
        }

    }




    

    render(){
        
        return(
            this.state.showRejectPopUp && <Modal isOpen={this.state.showRejectPopUp} >
                <div className={"modal-bg" + (this.state.OpenVersionModal == true  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 >{`Rejected reason for ${this.state.revisedPayload.param.documentTypeName}`}</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={(e)=>this.rejectPopUpAction(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <div>
                        <ModalBody Style="modal-body modalbodyssmall">

                                <div className="row ">
                                    <div className="col-8"></div>
                                    <div className="col-4 pb-2">
                                        {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                    </div>
                                </div> 
                                
                                <div className="row col-sm-12" style={{textAlign:"center",display:"none",top:"40%"}}>
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-sm-6">
                                        Comment:
                                    </div>
                                    <div className="col-sm-6">
                                        <textarea className="form-control" onChange={(e)=>this.hChange(e)}></textarea>
                                    </div>
                                </div>
                                

                                <div>
                                </div>    
                                
                                  
                        </ModalBody>
                    </div>
                    <div className="">    
                        <ModalFooter FooterStyle="modal-footer">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-2 float-right"  onClick={()=>this.formSaveAction()} type="submit">Save</button> 
                                <button className="btn2 btn-sms1 mt-2 ml-2 " onClick={()=>this.rejectPopUpAction(false)} type="submit">Close</button> 
                                
                            </div>
                        </ModalFooter>
                    </div>
            </div>
            </Modal>
   
        )
    }
}

const mapStateToProps  = (state) => ({ 
    comment: state.comment,
})
export default connect(mapStateToProps,
    //  {uploadVersionFile}
       {postComment,changeDocStatus}
     )(DocumentRejectPopUp)